export default __webpack_public_path__ + "static/media/label_act_sp.420c8e4e.svg";